import { ColumnProps } from 'antd/lib/table'
import Action from 'app/components/Core/DamageInfo/Action'
import Info from 'app/components/Core/DamageInfo/Info'
import KTable from 'app/components/Modules/Table/KTable'
import { RecordType, TableProps } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

import DamageStageTag from './StageTag'

const Table: React.FC<TableProps<IDamageItem>> = ({ params, ...others }) => {
  const { tAttribute, tComponent } = ToolBox.useString()
  const damageRecordType = RecordType.damage_item
  const damageInfoRecordType = RecordType.damage_info

  const columns: ColumnProps<IDamageItem>[] = [
    {
      title: tAttribute({ recordType: damageRecordType, attribute: 'name' }),
      dataIndex: 'name'
    },
    {
      title: tAttribute({ recordType: damageInfoRecordType, attribute: 'damage_stage' }),
      render: (_, record) => <DamageStageTag member={record} />
    },
    {
      title: tAttribute({ recordType: damageInfoRecordType, attribute: 'machine_name' }),
      dataIndex: 'machine_name'
    },
    {
      title: tAttribute({ recordType: damageInfoRecordType, attribute: 'damage_number' }),
      dataIndex: ['damage_info', 'damage_number']
    },
    {
      title: tAttribute({ recordType: damageInfoRecordType, attribute: 'damage_time' }),
      dataIndex: ['damage_info', 'damage_time']
    },
    {
      title: tComponent({ componentType: 'core', componentName: 'table', id: 'actions' }),
      render: (_, record) => <Action member={record.damage_info} />
    }
  ]

  return (
    <KTable<IDamageItem>
      recordType={RecordType.damage_item}
      size="small"
      params={params}
      rowClassName="pointer"
      expandable={{
        expandRowByClick: true,
        expandedRowRender: (record: IDamageItem) => <Info member={record.damage_info} />
      }}
      columns={columns}
      {...others}
    />
  )
}

export default Table
